const routes = [
    {
        path: "/page/messages",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "pagemessage_index"
        }
    },

];

export default routes;
